import styled from 'styled-components';

import { colors, transition } from 'theme';

import { ShareButton } from './ShareButton';

export const SocialButton = styled(ShareButton)`
  display: block;
  margin: 6px;
  border-radius: 50%;
  background: ${colors.platinum};
  color: ${colors.battleshipGrey};
  transition: all ${transition};
  &:hover,
  &:focus {
    background: ${colors.waterBlue};
    color: white;
  }
`;
